// extracted by mini-css-extract-plugin
module.exports = {"container":"BookmarkList_container__2OHti"};